import {
	faArrowRight as fasArrowRight,
	faBuilding as fasBuilding,
	faCalendarDays as fasCalendarDays,
} from "@awesome.me/kit-3777c2145e/icons/classic/solid";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import autobind from "autobind-decorator";
import type { FormApi } from "final-form";
import type { ReactNode } from "react";
import { Card } from "react-bootstrap";
import type { AbstractStepProps } from "@/component/assets/AbstractLeadForm/Steps/AbstractStep";
import { AbstractStep } from "@/component/assets/AbstractLeadForm/Steps/AbstractStep";
import { AbstractSubmitStep } from "@/component/assets/AbstractLeadForm/Steps/AbstractSubmitStep";
import nhpStartBg from "@/img/calculator/embed/corporate_loan/nhp.png";
import { ButtonLegacy, FormNumber, FormSelect } from "@/shared/ui";
import { COMPANY_LEGAL_FORMS } from "./Step1.data";

export interface StepFields {
	companyFoundYear: number;
	companyLegalForm: string;
}

interface Props extends AbstractStepProps {
	title?: string;
}

export class Step1 extends AbstractStep<StepFields, Props> {
	public static defaultProps = {
		...AbstractSubmitStep.defaultProps,
		title: "Nézd meg, hogy mennyi hitelt kaphat a céged!",
	};

	protected renderContent(_values: StepFields, form: FormApi<StepFields>): ReactNode {
		const { title } = this.props;

		return (
			<>
				<Card.Body>
					<div className="h3 mt-2 text-center text-uppercase text-primary">{title}</div>
					<FormNumber
						label="Alapítás éve:"
						placeholder="Add meg az évszámot"
						name="companyFoundYear"
						prepend={<FontAwesomeIcon icon={fasCalendarDays} />}
						validate={this.validCompanyFoundYear}
						onBlur={(value) => this.onCompanyFoundYearBlur(value, form)}
						required
					/>
					<FormSelect
						label="Társasági forma:"
						name="companyLegalForm"
						placeholder="Válaszd ki a társasági formát"
						prepend={<FontAwesomeIcon icon={fasBuilding} />}
						options={COMPANY_LEGAL_FORMS}
						required
					/>
					<div className="col-12 text-center mt-4">
						<img src={nhpStartBg} alt="NHP" width={298} height={183} loading="eager" />
					</div>
				</Card.Body>
				<Card.Footer className="text-center">
					<ButtonLegacy
						type="submit"
						icon={<FontAwesomeIcon icon={fasArrowRight} />}
						className={!form.getState().valid ? "disabled" : undefined}
					>
						Tovább
					</ButtonLegacy>
				</Card.Footer>
			</>
		);
	}

	@autobind
	private validCompanyFoundYear(foundYear: number): string {
		const companyFoundYear = Number(foundYear);

		if (companyFoundYear < 1800) {
			return "A megadható legalacsonyabb érték 1800!";
		}

		if (companyFoundYear > new Date().getFullYear()) {
			return "A cég alapítási éve nem lehet jövőbeli.";
		}

		return undefined;
	}

	@autobind
	private onCompanyFoundYearBlur(foundYear: number, form: FormApi<StepFields>): void {
		let companyFoundYear = foundYear;

		// Csak két számjegyet ad meg, akkor kiegészítjük
		if (companyFoundYear < 50) {
			companyFoundYear = 2000 + companyFoundYear;
		} else if (companyFoundYear < 100) {
			companyFoundYear = 1900 + companyFoundYear;
		}

		form.change("companyFoundYear", companyFoundYear);
	}

	protected getComponentName(): string {
		return "Step1";
	}
}
